import React, { useState, useEffect, useRef } from "react";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import axios from "axios";
import BannerDesktop from "./images/BannerBooknow.jpeg";

import BannerMobile from "./images/Banner01m.jpg";

export const JV = ({ match }) => {
  const IPTV_PLAN_ID = "0";
  const planID = match && match.params ? match.params.slug : "";

  // =========================================================
  // STATES
  // =========================================================

  const [planHeader, setplanHeader] = useState("");

  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");

  // =========================================================
  // CITY SEARCH DROPDOWN
  // =========================================================

  const [citySearch, setCitySearch] = useState("");
  const [cityDropdownOpen, setCityDropdownOpen] = useState(false);
  const cityDropdownRef = useRef(null);

  const [user_name, setusername] = useState("");
  const [user_mobile, setusermobile] = useState("");
  const [user_pincode, setUserPincode] = useState("");

  const [isDisabled, setIsDisabled] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // =========================================================
  // REFS
  // =========================================================

  const ref_name = useRef(null);
  const ref_mobile = useRef(null);
  const ref_state = useRef(null);
  const ref_city = useRef(null);
  const ref_pincode = useRef(null);

  // =========================================================
  // DECODE HTML
  // =========================================================

  const decodeHTML = function (html) {
    var txt = document.createElement("textarea");

    txt.innerHTML = html || "";

    return txt.value;
  };

  function createMarkup(content) {
    return {
      __html: decodeHTML(content),
    };
  }

  // =========================================================
  // GET PLAN HEADER
  // =========================================================

  useEffect(() => {
    if (!planID) {
      return;
    }

    axios
      .get(window.weburl + "api/get_current_plan.php?pid=" + planID)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          const data = response.data[0];

          let header = "";

          if (data.category) {
            header += data.category + " ";
          }

          if (data.pname) {
            header += data.pname + " ";
          }

          if (data.price) {
            header += "<i class='finr'></i>" + data.price + " ";
          }

          if (data.ptitle) {
            header += "With " + data.ptitle;
          }

          setplanHeader(header);
        }
      })
      .catch((error) => {
        console.log("Plan Header Error:", error);
      });
  }, [planID]);

  // =========================================================
  // GET STATES
  // =========================================================

  useEffect(() => {
    axios
      .get(window.weburl + "api/get_states.php")
      .then((response) => {
        setStates(response.data || []);
      })
      .catch((error) => {
        console.log("State Error:", error);
      });
  }, []);

  // =========================================================
  // GET CITIES
  // =========================================================

  const getCities = (state) => {
    setCitySearch("");
    setCityDropdownOpen(false);

    if (!state) {
      setCities([]);
      setSelectedCity("");
      return;
    }

    axios
      .get(window.weburl + "api/get_cities.php?sid=" + state)
      .then((response) => {
        setCities(response.data || []);
      })
      .catch((error) => {
        console.log("City Error:", error);
        setCities([]);
      });
  };

  // =========================================================
  // FILTER CITIES
  // =========================================================

  const filteredCities = cities.filter((city) => {
    const cityName = city.cityname || city.city || city.name || "";

    return cityName.toLowerCase().includes(citySearch.toLowerCase());
  });

  // =========================================================
  // CLOSE CITY DROPDOWN WHEN CLICKING OUTSIDE
  // =========================================================

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        cityDropdownRef.current &&
        !cityDropdownRef.current.contains(event.target)
      ) {
        setCityDropdownOpen(false);
        setCitySearch("");
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  // =========================================================
  // STATE CHANGE
  // =========================================================

  const handleStateChange = (event) => {
    const state = event.target.value;

    setSelectedState(state);

    // Reset city when state changes
    setSelectedCity("");
    setCitySearch("");
    setCityDropdownOpen(false);

    getCities(state);
  };

  // =========================================================
  // PHONE VALIDATION
  // =========================================================

  const isValidPhone = (phone) => {
    const regex = /^[6-9][0-9]{9}$/;

    return regex.test(phone);
  };

  // =========================================================
  // FORM VALIDATION
  // =========================================================

  const validateForm = () => {
    // MOBILE REQUIRED
    if (!isValidPhone(user_mobile)) {
      alert("Please enter valid Mobile number");

      if (ref_mobile.current) {
        ref_mobile.current.focus();
      }

      return false;
    }

    // STATE REQUIRED
    if (!selectedState) {
      alert("Please select State");

      if (ref_state.current) {
        ref_state.current.focus();
      }

      return false;
    }

    // CITY REQUIRED
    if (!selectedCity) {
      alert("Please select City");

      setCityDropdownOpen(true);

      if (ref_city.current) {
        ref_city.current.focus();
      }

      return false;
    }

    // PIN CODE REQUIRED
    // PIN CODE OPTIONAL (if entered, must be 6 digits)
    if (user_pincode && !/^[0-9]{6}$/.test(user_pincode)) {
      alert("Please enter a valid 6-digit Pin Code");

      if (ref_pincode.current) {
        ref_pincode.current.focus();
      }

      return false;
    }

    return true;
  };

  // =========================================================
  // ENABLE / DISABLE BUTTON
  // =========================================================

  const handledisable = () => {
    if (isValidPhone(user_mobile)) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  };

  // =========================================================
  // SUBMIT FORM
  // =========================================================

  const handleSubmit = (event) => {
    if (event) {
      event.preventDefault();
    }

    if (isSubmitting) {
      return false;
    }

    if (!validateForm()) {
      return false;
    }

    setIsSubmitting(true);

    const buttonText = document.getElementById("submit_button_text");

    if (buttonText) {
      buttonText.innerText = "SUBMITTING...";
    }

    const fData = new FormData();

    fData.append("td_name", "bookings");
    fData.append("catID", "");
    fData.append("planID", IPTV_PLAN_ID);
    fData.append("user_name", user_name);
    fData.append("user_mobile", user_mobile);
    fData.append("user_state", selectedState);
    fData.append("user_city", selectedCity);
    fData.append("user_address", user_pincode);
    fData.append("utm_url", window.location.href);
    fData.append("ref", "GADS_JV");

    const apiURL = window.weburl + "api/insert_hook.php";

    axios
      .post(apiURL, fData)
      .then((response) => {
        console.log("BOOKING RESPONSE:", response.data);

        const responseText = response.data ? response.data.toString() : "";

        if (responseText.indexOf("Thank you!") !== -1) {
          if (window.gtag) {
            window.gtag("event", "conversion", {
              send_to: "AW-801924308/HeMjCImtpfIbENTJsf4C",
            });
          }

          if (window.fbq) {
            window.fbq("track", "Lead");
          }

          sessionStorage.setItem("thankYouReturnUrl", "/JV");

          setTimeout(() => {
            window.location.href = "/thank-you";
          }, 500);

          return;
        }

        alert(responseText || "Something went wrong.");

        setIsSubmitting(false);
        setIsDisabled(true);

        if (buttonText) {
          buttonText.innerText = "Submit";
        }
      })
      .catch((error) => {
        console.log("BOOKING ERROR:", error);

        alert("Something went wrong. Please try again.");

        setIsSubmitting(false);

        if (buttonText) {
          buttonText.innerText = "Submit";
        }
      });

    return false;
  };

  // =========================================================
  // RENDER
  // =========================================================

  return (
    <>
      <Header />

      <section id="banner" className="p-0">
        <div className="banner booknow filter m-0 h-120"></div>
      </section>

      <section id="login" className="p-0">
        <div className="booknow filter m-0">
          <div className="container">
            <div className="row">
              <div className="web-container">
                <div className="title m-0">
                  <span>Book Now</span>
                </div>

                <div className="heading">
                  <h4
                    dangerouslySetInnerHTML={createMarkup(
                      "Book your Netplus " + planHeader,
                    )}
                  ></h4>
                </div>

                <div className="booknow-layout">
                  {/* =================================================
                      CAROUSEL
                  ================================================= */}

                  <div className="booknow-video booknow-carousel">
                    <picture>
                      <source
                        media="(max-width: 767px)"
                        srcSet={BannerMobile}
                      />
                      <img
                        src={BannerDesktop}
                        alt="Book now"
                        className="carousel-slide active"
                      />
                    </picture>
                  </div>

                  {/* =================================================
                      FORM
                  ================================================= */}

                  <div className="footerform bookingform">
                    <div className="form">
                      <form onSubmit={handleSubmit}>
                        <ul>
                          {/* =================================================
                              NAME
                          ================================================= */}

                          <li>
                            <input
                              type="text"
                              name="user_name"
                              id="user_name"
                              placeholder="Your name"
                              value={user_name}
                              onChange={(e) => {
                                setusername(e.target.value);
                              }}
                              onBlur={handledisable}
                              ref={ref_name}
                            />
                          </li>

                          {/* =================================================
                              MOBILE
                          ================================================= */}

                          <li>
                            <input
                              type="text"
                              name="user_mobile"
                              id="user_mobile"
                              placeholder="Mobile number*"
                              maxLength="10"
                              value={user_mobile}
                              onChange={(e) => {
                                const value = e.target.value.replace(
                                  /[^0-9]/g,
                                  "",
                                );

                                setusermobile(value);
                              }}
                              onBlur={handledisable}
                              ref={ref_mobile}
                            />
                          </li>

                          {/* =================================================
                              STATE
                          ================================================= */}

                          <li>
                            <select
                              name="selectedState"
                              id="selectedState"
                              value={selectedState}
                              onChange={handleStateChange}
                              ref={ref_state}
                              required
                            >
                              <option value="">Select State*</option>

                              {states.map((state, index) => (
                                <option
                                  key={state.sno || state.stateid || index}
                                  value={state.sno || state.stateid}
                                >
                                  {state.state || state.sname || state.name}
                                </option>
                              ))}
                            </select>
                          </li>

                          {/* =================================================
                              SEARCHABLE CITY
                          ================================================= */}

                          <li>
                            <div
                              className="city-dropdown"
                              ref={cityDropdownRef}
                            >
                              <input
                                type="text"
                                name="selectedCity"
                                id="selectedCity"
                                value={
                                  cityDropdownOpen
                                    ? citySearch
                                    : cities.find(
                                          (city) =>
                                            String(city.cityid || city.sno) ===
                                            String(selectedCity),
                                        )
                                      ? cities.find(
                                          (city) =>
                                            String(city.cityid || city.sno) ===
                                            String(selectedCity),
                                        ).cityname ||
                                        cities.find(
                                          (city) =>
                                            String(city.cityid || city.sno) ===
                                            String(selectedCity),
                                        ).city ||
                                        cities.find(
                                          (city) =>
                                            String(city.cityid || city.sno) ===
                                            String(selectedCity),
                                        ).name ||
                                        ""
                                      : ""
                                }
                                placeholder="Select City*"
                                autoComplete="off"
                                disabled={!selectedState}
                                readOnly={!cityDropdownOpen}
                                required
                                ref={ref_city}
                                onFocus={() => {
                                  if (!selectedState) {
                                    return;
                                  }

                                  setCityDropdownOpen(true);
                                  setCitySearch("");
                                }}
                                onClick={() => {
                                  if (!selectedState) {
                                    return;
                                  }

                                  setCityDropdownOpen(true);
                                  setCitySearch("");
                                }}
                                onChange={(e) => {
                                  setCitySearch(e.target.value);
                                  setCityDropdownOpen(true);
                                }}
                              />

                              {/* Arrow */}

                              <span
                                className={
                                  "city-dropdown-arrow" +
                                  (cityDropdownOpen ? " open" : "")
                                }
                                onClick={() => {
                                  if (!selectedState) {
                                    return;
                                  }

                                  setCityDropdownOpen((prev) => !prev);

                                  if (!cityDropdownOpen) {
                                    setCitySearch("");
                                  }
                                }}
                              >
                                ˅
                              </span>

                              {/* Dropdown */}

                              {cityDropdownOpen && selectedState && (
                                <div className="city-options">
                                  {/* Search box */}

                                  <div className="city-search-box">
                                    <input
                                      type="text"
                                      placeholder="Search city..."
                                      value={citySearch}
                                      onChange={(e) => {
                                        setCitySearch(e.target.value);
                                        setCityDropdownOpen(true);
                                      }}
                                      autoFocus
                                    />
                                  </div>

                                  {/* City list */}

                                  <div className="city-list">
                                    {filteredCities.length > 0 ? (
                                      filteredCities.map((city, index) => {
                                        const cityId =
                                          city.cityid || city.sno || index;

                                        const cityName =
                                          city.cityname ||
                                          city.city ||
                                          city.name ||
                                          "";

                                        return (
                                          <div
                                            key={cityId}
                                            className="city-option"
                                            onClick={() => {
                                              setSelectedCity(cityId);

                                              setCitySearch("");

                                              setCityDropdownOpen(false);
                                            }}
                                          >
                                            {cityName}
                                          </div>
                                        );
                                      })
                                    ) : (
                                      <div className="no-city">
                                        No city found
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                          </li>

                          {/* PIN CODE */}

                          <li>
                            <input
                              type="text"
                              name="user_pincode"
                              id="user_pincode"
                              placeholder="Pin Code"
                              maxLength="6"
                              inputMode="numeric"
                              autoComplete="postal-code"
                              value={user_pincode}
                              onChange={(e) => {
                                const value = e.target.value.replace(
                                  /[^0-9]/g,
                                  "",
                                );
                                setUserPincode(value);
                              }}
                              ref={ref_pincode}
                            />
                          </li>

                          {/* =================================================
                              SUBMIT
                          ================================================= */}

                          <li className="buttnprop">
                            <input
                              type="submit"
                              value=""
                              id="submit_button"
                              disabled={isDisabled || isSubmitting}
                            />

                            <span
                              id="submit_button_text"
                              className={isDisabled ? "disabled" : ""}
                              onClick={(e) => {
                                if (!isDisabled && !isSubmitting) {
                                  handleSubmit(e);
                                }
                              }}
                            >
                              {isSubmitting ? "SUBMITTING..." : "Submit"}
                            </span>
                          </li>
                        </ul>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      {/* =========================================================
          SEARCHABLE CITY DROPDOWN CSS
      ========================================================= */}
    </>
  );
};
